import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatButtonModule, ReactiveFormsModule, CommonModule, TranslateModule],  
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent { 
    loginForm: FormGroup;
    isLoading = false;
    errorMessage = '';            
    linkedinUrl: string = '';
    errorEmail: boolean = false;
    errorEmailConfirmation: boolean = false;
    
    constructor(private fb: FormBuilder, private http: HttpClient, private router: Router) {
        this.loginForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required]]
        });

        this.linkedinUrl = environment.linkedinUrl;
    } 


    login(type: string) {
        this.errorEmail = false;

        if (type === 'linkedin') {
            window.location.href = this.linkedinUrl;
            return;
        } 
        if (this.loginForm.valid) {
            this.isLoading = true;
            this.http.post(`${environment.url}/api/login`, this.loginForm.value).subscribe({
                next: (response: any) => {
                    console.log(response);
                    this.isLoading = false;
                    const step_register = response.step_register;
                    document.cookie = `manualStep=${step_register}; path=/;`;
                    if (response.is_profiled) {
                        this.router.navigate(['/session/candidate-profiling-success']);
                    } else {
                        if (step_register === 6) {
                            this.router.navigate(['/session/candidate-profiling']);
                        } else {
                            this.router.navigate(['/session/register/manual']);
                        }
                    }
                },
                error: (error: any) => {
                    console.error('Error:', error);
                    this.isLoading = false;
                    if (error.status === 401) {
                        this.errorMessage = "Credenciales inválidas.";
                        this.errorEmail = true;
                    } else if (error.status === 400 && error.error.error.startsWith('Email')) {
                        this.errorMessage = "El email ya está registrado. ¿Quieres iniciar sesión?";
                        this.errorEmail = false;
                        this.errorEmailConfirmation = true;
                    } else if (error.status === 400) {
                        this.errorMessage = "Información incompleta.";
                    } else {
                        this.errorMessage = 'Ocurrió un error desconocido.';
                    }
                }
            });
        } else {
            this.markAllAsTouched();
            this.errorEmail = true;
            console.error('Form is invalid');
        }
    }

    private markAllAsTouched() {
        Object.values(this.loginForm.controls).forEach(control => {
            control.markAsTouched();
        });
    }

    

}
